import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const defaultSideBarState = {
  isCollapsed: false,
  isOpen: false,
};

const sideBarAtom = atomWithStorage("sideBar", defaultSideBarState);

const useSideBarAtom = () => {
  const atom = useAtom(sideBarAtom);
  return atom;
};

export const useSetSideBarAtom = () => useSetAtom(sideBarAtom);

export default useSideBarAtom;
